import React, { useState, useEffect } from 'react'
import api from '@services/api'
import { useButtonWidth } from '@services/layout'
import TextInput from '@components/Form/TextInput'
import SelectInput from '@components/Form/SelectInput'
import TextAreaInput from '@components/Form/TextAreaInput'
import RequiredText from '@components/Form/RequiredText'
import ConfirmModal from '@components/Modals/ConfirmModal'
import MessageModal from '@components/Modals/MessageModal'
import {
    PageSubTitle,
    FormWrapper,
    FormRow,
    SubmitBtn,
    SubmitBtnContainer,
    GrayWrapper,
    ErrorText,
} from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({ show, groups }) => {
    const buttonWidth = useButtonWidth()
    const [mailingList, setMailingList] = useState(null)
    const [mailingListValid, setMailingListValid] = useState(null)
    const [subject, setSubject] = useState(null)
    const [subjectValid, setSubjectValid] = useState(null)
    const [body, setBody] = useState(null)
    const [bodyValid, setBodyValid] = useState(null)
    const [groupsOptions, setGroupsOptions] = useState(null)
    const [error, setError] = useState(null)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showDoneModal, setShowDoneModal] = useState(false)
    const [emailRecipients, setEmailRecipients] = useState(0)

    useEffect(() => {
        if (!groupsOptions && groups) {
            setGroupsOptions(groups)
        }
    }, [groups])

    useEffect(() => {
        setError(null)
        setErrorPerField(bodyValid, 'גוף ההודעה לא תקינה')
        setErrorPerField(subjectValid, 'כותרת האימייל לא תקינה')
        setErrorPerField(mailingListValid, 'רשימת נמענים לא תקינה')
    }, [mailingListValid, subjectValid, bodyValid])

    const setErrorPerField = (field, error) => {
        if (field === false) {
            setError(error)
        }
    }

    const formValid = () => mailingListValid && subjectValid && bodyValid

    const sendGeneralEmail = () => {
        setShowConfirmModal(false)
        api.sendGeneralEmail(mailingList, subject, body).subscribe(
            (res) => {
                // console.log('sendGeneralEmail res', res)
                setEmailRecipients(res.data.number_of_emails)
                setShowDoneModal(true)
            },
            (err) => console.log('sendGeneralEmail error', err)
        )
    }

    if (!show) {
        return null
    }

    return (
        <GrayWrapper>
            <PageSubTitle>
                {i18n.t('settings_headers.email_distributor')}
            </PageSubTitle>

            <FormWrapper>
                <FormRow>
                    <SelectInput
                        value={mailingList || ''}
                        placeholder={'בחר/י'}
                        label={'רשימת נמענים'}
                        onSelect={(group) => setMailingList(group)}
                        options={groupsOptions}
                        width={buttonWidth}
                        onDoneEdit={setMailingListValid}
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        label={'כותרת האימייל'}
                        text={subject || ''}
                        onChangeText={setSubject}
                        width={'100%'}
                        onDoneEdit={setSubjectValid}
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextAreaInput
                        label={'גוף ההודעה'}
                        text={body || ''}
                        onChangeText={setBody}
                        minHeight="100px"
                        onDoneEdit={setBodyValid}
                        required
                    />
                </FormRow>
                <FormRow>
                    <RequiredText />
                </FormRow>
                <SubmitBtnContainer>
                    <SubmitBtn
                        onClick={() => setShowConfirmModal(true)}
                        disabled={!formValid()}>
                        שליחה
                    </SubmitBtn>
                </SubmitBtnContainer>
                <FormRow>
                    <ErrorText>{error}</ErrorText>
                </FormRow>
            </FormWrapper>

            <ConfirmModal
                isOpen={showConfirmModal}
                onCancel={() => setShowConfirmModal(false)}
                onConfirm={sendGeneralEmail}
                title={'אישור שליחה'}
                mainText={
                    'האם את/ה בטוח/ה שברצונך לשלוח את האימייל לכל המשתמשים שבחרת?'
                }
            />
            <MessageModal
                isOpen={showDoneModal}
                title={'האימייל נשלח בהצלחה'}
                mainText={'האימייל נשלח לכ-' + emailRecipients + ' משתמשים'}
                onClose={() => setShowDoneModal(false)}
            />
        </GrayWrapper>
    )
}
